module.exports = __webpack_public_path__ + "img/how-to-use.215f6795.png";